var map = {
	"./Account/Show": 1711,
	"./Account/Show.vue": 1711,
	"./Auth/Login": 7154,
	"./Auth/Login.vue": 7154,
	"./Brands/Create": 3313,
	"./Brands/Create.vue": 3313,
	"./Brands/Edit": 3418,
	"./Brands/Edit.vue": 3418,
	"./Brands/Index": 7260,
	"./Brands/Index.vue": 7260,
	"./CashClosures/Index": 8843,
	"./CashClosures/Index.vue": 8843,
	"./CashClosures/Show": 7678,
	"./CashClosures/Show.vue": 7678,
	"./CashRegisters/Close": 8750,
	"./CashRegisters/Close.vue": 8750,
	"./CashRegisters/Create": 7830,
	"./CashRegisters/Create.vue": 7830,
	"./CashRegisters/DailyReport": 6310,
	"./CashRegisters/DailyReport.vue": 6310,
	"./CashRegisters/Edit": 2855,
	"./CashRegisters/Edit.vue": 2855,
	"./CashRegisters/Index": 2054,
	"./CashRegisters/Index.vue": 2054,
	"./CashRegisters/Open": 61,
	"./CashRegisters/Open.vue": 61,
	"./CashRegisters/Show": 3824,
	"./CashRegisters/Show.vue": 3824,
	"./CashTransactions/Create": 2521,
	"./CashTransactions/Create.vue": 2521,
	"./CashTransactions/Index": 7172,
	"./CashTransactions/Index.vue": 7172,
	"./Clients/Payments/Create": 559,
	"./Clients/Payments/Create.vue": 559,
	"./Contacts/Create": 4640,
	"./Contacts/Create.vue": 4640,
	"./Contacts/Edit": 2437,
	"./Contacts/Edit.vue": 2437,
	"./Contacts/Index": 1214,
	"./Contacts/Index.vue": 1214,
	"./Contacts/Show": 9151,
	"./Contacts/Show.vue": 9151,
	"./Dashboard/Index": 3513,
	"./Dashboard/Index.vue": 3513,
	"./Dealers/Edit": 4793,
	"./Dealers/Edit.vue": 4793,
	"./Dealers/Index": 798,
	"./Dealers/Index.vue": 798,
	"./Deposits/Create": 3444,
	"./Deposits/Create.vue": 3444,
	"./Deposits/Edit": 2279,
	"./Deposits/Edit.vue": 2279,
	"./Deposits/Index": 9408,
	"./Deposits/Index.vue": 9408,
	"./Deposits/Products": 2534,
	"./Deposits/Products.vue": 2534,
	"./Deposits/Transfer": 6478,
	"./Deposits/Transfer.vue": 6478,
	"./Deposits/TransferCreate": 6505,
	"./Deposits/TransferCreate.vue": 6505,
	"./Devolutions/Create": 9463,
	"./Devolutions/Create.vue": 9463,
	"./Devolutions/Index": 4216,
	"./Devolutions/Index.vue": 4216,
	"./Devolutions/Show": 3409,
	"./Devolutions/Show.vue": 3409,
	"./Groups/Create": 4621,
	"./Groups/Create.vue": 4621,
	"./Groups/Edit": 3059,
	"./Groups/Edit.vue": 3059,
	"./Groups/Index": 494,
	"./Groups/Index.vue": 494,
	"./Information": 8242,
	"./Information.vue": 8242,
	"./Inventories/Create": 2190,
	"./Inventories/Create.vue": 2190,
	"./Inventories/Index": 6457,
	"./Inventories/Index.vue": 6457,
	"./Inventories/Show": 1049,
	"./Inventories/Show.vue": 1049,
	"./LogSystem/Index": 3929,
	"./LogSystem/Index.vue": 3929,
	"./Media/Index": 5852,
	"./Media/Index.vue": 5852,
	"./Orders/Create": 3284,
	"./Orders/Create.vue": 3284,
	"./Orders/CreateClient": 2877,
	"./Orders/CreateClient.vue": 2877,
	"./Orders/Index": 3672,
	"./Orders/Index.vue": 3672,
	"./Orders/Pos": 995,
	"./Orders/Pos.vue": 995,
	"./Orders/PosShow": 4756,
	"./Orders/PosShow.vue": 4756,
	"./Orders/Show": 5230,
	"./Orders/Show.vue": 5230,
	"./Organizations/Create": 8185,
	"./Organizations/Create.vue": 8185,
	"./Organizations/Edit": 1408,
	"./Organizations/Edit.vue": 1408,
	"./Organizations/Index": 1547,
	"./Organizations/Index.vue": 1547,
	"./ProductCategories/Create": 6890,
	"./ProductCategories/Create.vue": 6890,
	"./ProductCategories/Edit": 2997,
	"./ProductCategories/Edit.vue": 2997,
	"./ProductCategories/Index": 7448,
	"./ProductCategories/Index.vue": 7448,
	"./Products/Create": 935,
	"./Products/Create.vue": 935,
	"./Products/Edit": 5868,
	"./Products/Edit.vue": 5868,
	"./Products/Index": 485,
	"./Products/Index.vue": 485,
	"./Providers/Create": 6815,
	"./Providers/Create.vue": 6815,
	"./Providers/Edit": 1550,
	"./Providers/Edit.vue": 1550,
	"./Providers/Index": 1171,
	"./Providers/Index.vue": 1171,
	"./Providers/Show": 8962,
	"./Providers/Show.vue": 8962,
	"./Reports/Index": 5586,
	"./Reports/Index.vue": 5586,
	"./Request": 57,
	"./Request.vue": 57,
	"./Requests/Edit": 5159,
	"./Requests/Edit.vue": 5159,
	"./Requests/Index": 6086,
	"./Requests/Index.vue": 6086,
	"./Shopping/Create": 553,
	"./Shopping/Create.vue": 553,
	"./Shopping/Edit": 7854,
	"./Shopping/Edit.vue": 7854,
	"./Shopping/Index": 29,
	"./Shopping/Index.vue": 29,
	"./Shopping/Show": 2601,
	"./Shopping/Show.vue": 2601,
	"./Spents/Create": 6431,
	"./Spents/Create.vue": 6431,
	"./Spents/Edit": 7076,
	"./Spents/Edit.vue": 7076,
	"./Spents/Index": 5320,
	"./Spents/Index.vue": 5320,
	"./SuccessApply": 1491,
	"./SuccessApply.vue": 1491,
	"./Taxes/Create": 7968,
	"./Taxes/Create.vue": 7968,
	"./Taxes/Edit": 5400,
	"./Taxes/Edit.vue": 5400,
	"./Taxes/Index": 2348,
	"./Taxes/Index.vue": 2348,
	"./Users/Create": 7218,
	"./Users/Create.vue": 7218,
	"./Users/Edit": 9663,
	"./Users/Edit.vue": 9663,
	"./Users/Index": 1294,
	"./Users/Index.vue": 1294,
	"./Version/Index": 434,
	"./Version/Index.vue": 434
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8846;